import idp from '@innovyze/stylovyze/lib/apis/idp.api';
export const getDomainIdentityService = (domain) => {
    return idp.get(`/idp/${domain}`);
};
